/* VisorDock — small progressive enhancements. Everything works without this file. */
(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    var value = '';
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '${{amount}}');
    var type = match ? match[1] : 'amount';
    function fmt(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    switch (type) {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Gallery (mobile scroll-snap counter + dots) ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-gallery-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children);
    var count = root.querySelector('[data-gallery-count]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));

    function setCurrent(i) {
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }

    function goTo(i) {
      var slide = slides[i];
      if (!slide) return;
      var horizontal = track.scrollWidth > track.clientWidth + 2;
      if (horizontal) {
        track.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }
      setCurrent(i);
    }

    if ('IntersectionObserver' in window) {
      var visible = slides.map(function () { return false; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible[slides.indexOf(e.target)] = e.isIntersecting && e.intersectionRatio >= 0.6;
        });
        var first = visible.indexOf(true);
        if (first > -1) setCurrent(first);
      }, { root: track, threshold: [0, 0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    return {
      showMedia: function (mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return; }
        }
      }
    };
  }

  /* ---------- Variant picker ---------- */
  function initProduct(section) {
    var gallery = initGallery(section);
    var form = section.querySelector('[data-product-form]');
    var dataEl = section.querySelector('[data-product-json]');
    var picker = section.querySelector('[data-variant-picker]');
    if (!picker) return;

    var product = null;
    try { product = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { product = null; }
    var moneyFormat = section.getAttribute('data-money-format');

    picker.addEventListener('change', function (event) {
      var input = event.target;
      var group = input.closest('[data-option-group]');
      if (group) {
        var label = group.querySelector('[data-option-value]');
        if (label) label.textContent = input.value;
      }

      // Planned colours (no product yet): swap gallery image only.
      if (!product) {
        if (input.dataset.mediaId && gallery) gallery.showMedia(input.dataset.mediaId);
        return;
      }

      var selected = Array.prototype.map.call(
        picker.querySelectorAll('[data-option-group]'),
        function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; }
      );
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      updateVariant(variant);
    });

    function updateVariant(variant) {
      var idInput = form && form.querySelector('[name="id"]');
      var price = section.querySelector('[data-price]');
      var compare = section.querySelector('[data-compare-price]');
      var avail = section.querySelectorAll('[data-availability]');
      var buttons = document.querySelectorAll('[data-add-button="' + section.id + '"]');
      var barPrice = document.querySelector('[data-buybar-price="' + section.id + '"]');

      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; b.querySelector('[data-add-label]').textContent = b.dataset.unavailable; });
        avail.forEach(function (a) { a.textContent = section.dataset.unavailable; });
        return;
      }

      if (idInput) idInput.value = variant.id;
      var priceText = formatMoney(variant.price, moneyFormat);
      if (price) price.textContent = priceText;
      if (barPrice) barPrice.textContent = priceText;
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        if (!compare.hidden) compare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      }
      avail.forEach(function (a) { a.textContent = variant.available ? section.dataset.inStock : section.dataset.soldOut; });
      buttons.forEach(function (b) {
        b.disabled = !variant.available;
        b.querySelector('[data-add-label]').textContent = variant.available ? b.dataset.add : b.dataset.soldOut;
      });

      if (variant.featured_media && gallery) gallery.showMedia(variant.featured_media.id);

      if (section.hasAttribute('data-update-url') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  /* ---------- Mobile purchase bar ---------- */
  function initBuybar(bar) {
    var target = document.getElementById(bar.getAttribute('data-buybar-for'));
    if (!target) return;
    var shown = null;
    var ticking = false;
    // Visible only once the in-page purchase button has scrolled above the viewport.
    function update() {
      ticking = false;
      var passed = target.getBoundingClientRect().bottom < 0;
      if (passed === shown) return;
      shown = passed;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = passed ? 0 : -1; });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Mobile menu: close on link click / Escape ---------- */
  function initMenu(menu) {
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) menu.removeAttribute('open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.hasAttribute('open')) {
        menu.removeAttribute('open');
        menu.querySelector('summary').focus();
      }
    });
  }

  /* ---------- Horizontal step gallery: arrow buttons ---------- */
  function initScroller(section) {
    var track = section.querySelector('[data-scroller]');
    var prev = section.querySelector('[data-scroll-prev]');
    var next = section.querySelector('[data-scroll-next]');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      return card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      section.querySelector('.paddles').hidden = max <= 0;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var items = root.querySelectorAll('.reveal:not(.is-in)');
    document.documentElement.classList.add('reveal-on'); /* hide-until-seen only once this script runs */
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Product bar: appears once the hero has scrolled away ---------- */
  function initProductbar(bar) {
    var hero = document.querySelector('.hero') || document.querySelector('[data-site-header]');
    if (!hero) return;
    var shown = null;
    var ticking = false;
    function update() {
      ticking = false;
      var past = hero.getBoundingClientRect().bottom < 0;
      if (past === shown) return;
      shown = past;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = past ? 0 : -1; });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Header nav: mark the section currently in view ---------- */
  function initSectionNav() {
    if (!('IntersectionObserver' in window)) return;
    var links = Array.prototype.slice.call(document.querySelectorAll('.nav a[href*="#"]'));
    var map = {};
    links.forEach(function (a) {
      var id = a.getAttribute('href').split('#')[1];
      var el = id && document.getElementById(id);
      if (el) map[id] = { link: a, el: el };
    });
    var ids = Object.keys(map);
    if (!ids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var item = map[e.target.id];
        if (!item) return;
        if (e.isIntersecting) {
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          item.link.setAttribute('aria-current', 'true');
        } else if (item.link.getAttribute('aria-current')) {
          item.link.removeAttribute('aria-current');
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    ids.forEach(function (id) { io.observe(map[id].el); });
  }

  /* ---------- Build-on-scroll ----------
     Each section assembles once as it reaches the viewport: images slide out
     like the tray leaving its housing, rows wipe in and draw their rules,
     headings settle. Content is fully visible without JS, and with
     prefers-reduced-motion nothing is hidden or moved. */
  function initBuild() {
    // motion-ok is set in the head (snippets/theme-styles.liquid): motion allowed, or the
    // owner preview ?motion=on, which lasts for this browser tab only.
    if (!document.documentElement.classList.contains('motion-ok') || !('IntersectionObserver' in window)) return;

    var roles = [
      ['b-unmask', '.media img'],
      ['b-wipe', '.topic, .faq__item, .parts__list li, .detail__points li, .buy__facts li, .buy__info details, .measure li'],
      ['b-rise', 'h2, .copy, .detail-card h3, .detail-card p, .buy__price, .buy__group, .buy__actions, .fit__legend, .diagram-card svg, .signup__form, .arrow-link, .paddles']
    ];
    var sections = Array.prototype.slice.call(document.querySelectorAll('main > .shopify-section'));
    var pending = [];

    sections.forEach(function (section, s) {
      if (s === 0 || section.querySelector('.hero')) return; // the hero has its own moment
      var count = 0;
      roles.forEach(function (role) {
        section.querySelectorAll(role[1]).forEach(function (el) {
          if (el.closest('.b-rise, .b-wipe, .b-unmask') && role[0] !== 'b-unmask') return;
          if (el.classList.contains('b-wipe') || el.classList.contains('b-rise') || el.classList.contains('b-unmask')) return;
          el.classList.add(role[0]);
          el.style.setProperty('--d', Math.min(count, 9) * 70 + 'ms');
          count++;
        });
      });
      if (count) {
        section.classList.add('build-ready');
        pending.push(section);
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-built');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    pending.forEach(function (section) { io.observe(section); });

    // Safety net: any section whose top has reached the lower part of the
    // screen (or that a visitor jumped past) is built, so content never stays hidden.
    var ticking = false;
    function sweep() {
      ticking = false;
      var limit = window.innerHeight * 0.92;
      pending = pending.filter(function (section) {
        if (section.getBoundingClientRect().top < limit) {
          section.classList.add('is-built');
          io.unobserve(section);
          return false;
        }
        return true;
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking && pending.length) { ticking = true; window.requestAnimationFrame(sweep); }
    }, { passive: true });
    window.addEventListener('hashchange', sweep);
    window.addEventListener('load', sweep);
  }

  /* ---------- Story statement: wrap each word so it can light up on scroll ----------
     The effect itself lives in showroom.css and only runs where scroll-driven
     animation is supported and motion is allowed; otherwise the words just read normally. */
  function initWords(root) {
    root.querySelectorAll('.story__card .story-text:not(.has-words)').forEach(function (el) {
      var index = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.nodeValue.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var span = document.createElement('span');
              span.className = 'w';
              span.style.setProperty('--i', index++);
              span.textContent = part;
              frag.appendChild(span);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1) {
            walk(child);
          }
        });
      })(el);
      el.classList.add('has-words');
    });
  }

  function initAll(root) {
    if (root === document) { initSectionNav(); initBuild(); }
    initWords(root);
    root.querySelectorAll('[data-productbar]').forEach(initProductbar);
    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    root.querySelectorAll('[data-buybar-for]').forEach(initBuybar);
    root.querySelectorAll('[data-menu]').forEach(initMenu);
    root.querySelectorAll('[data-scroller-section]').forEach(initScroller);
    initReveal(root);
  }

  function init() { initAll(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-initialise sections when edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
